<script>

    export let address
    export let icon
</script>
<style>
    .address h4 {
        color: var(--near-ink);
        font-size: 0.8em;
    }
</style>
<div class="">
    <div class="flex mb1 items-center">
        {#if icon}
            <span class="icon small"><svelte:component this={icon}/></span>
        {/if}
        <h4 class='bold'>
            <slot>Title</slot>
        </h4>
    </div>
    <div class="address">
        <h4>{address.Name}</h4>
        <h4>{address.AddressLine1}</h4>
        <h4>{address.City}, {address.State} USA</h4>
    </div>
</div>